import React, { useState } from "react";
import {
  Layout,
  Menu,
  Row,
  Col,
  Dropdown,
  Space,
  Button,
  Popconfirm,
} from "antd";
import "antd/dist/reset.css";
import {
  UserOutlined,
  TeamOutlined,
  SettingOutlined,
  ProfileOutlined,
  LogoutOutlined,
  EyeOutlined,
  QuestionOutlined,
  InfoCircleOutlined,
  FilePptOutlined,
} from "@ant-design/icons";
import Joyride from "react-joyride";

import AppRouter from "./Routes";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { logout, getProfile, isAuthorizedRole } from "../security/AppSecurity";
import Tour from "../components/custom/Tour";

import UserAddModal from "../components/usermanagement/UserAddModal";
import { TimerControl } from "../components/custom/TimerControl";
import { FooterView } from "../components/home/FooterView";
import { MenuView } from "../components/home/MenuView";
import { HeaderView } from "../components/home/HeaderView";

const { Header, Content, Footer } = Layout;

export const AuthorizedLayout = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState(getProfile());
  const [visible, setVisible] = useState(false);
  const [userVisible, setUserVisible] = useState(false);
  const [hasUpdated, setHasUpdated] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const [steps, setSteps] = useState([
    {
      target: ".content-container",
      title: `New on this website ? `,
      content: "This section gives an overview of the NYS programme.",
      disableBeacon: true,
    },
    {
      target: ".profile",
      title: `Profile `,
      content:
        "Profile button allows you to perform the following: Update password, Manage profile & Logout.",
    },
    {
      target: ".side-menu",
      title: `Application `,
      content: "This link allows you to apply for the NYS programme.",
    },
  ]);

  const [run, setRun] = useState(false);
  const [tour, setTour] = useState();

  const navigate = useNavigate();

  let path = `/nys/candidate/registration`;

  const handleCancel = () => {
    setUserVisible(false);
  };

  const Logout = () => {
    logout();
  };
  const cancel = () => {};




  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  return (
    <div>
      <Layout
        className="site-layout"
        style={{
          marginLeft: 200,
        }}
      >
        <Header>
          <HeaderView />
        </Header>
        <MenuView />

        <Content style={{ margin: "0 16px" }}>
          <>
            <TimerControl />
            <AppRouter />
          </>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          <FooterView />
        </Footer>

        <UserAddModal
          show={accepted && userVisible}
          onCancel={handleCancel}
          acceptedTerms={accepted}
        />
      </Layout>
    </div>
  );
};

export default AuthorizedLayout;
